module.exports = __webpack_public_path__ + "img/headerBg.f0217424.webp";